import React, { useState, useEffect, useMemo ,useRef,useCallback } from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  Box,
  Divider,
  Tooltip,
  Modal,
  CircularProgress,
  Paper,
  Button,
  Avatar,useTheme,
  LinearProgress,
  Menu,
  Stack,
  Dialog,
  DialogTitle,
  TextField,
  Checkbox,
  DialogContent,
} from '@mui/material';
// import { styled } from '@mui/material/styles';
import { Edit, ContentCopy, Timeline, StopCircle ,Tag,Person,AccessTime,CalendarToday,Close ,
    MoreVert,
    PauseCircle,
    PlayCircle,
    ErrorOutline ,
    Send,
    Visibility,
    Phone,
    Share,
    Timer

} from '@mui/icons-material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerIcon from '@mui/icons-material/Timer';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ApiService from '../../API/Requesthandler'
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';
import {People,
    InsertDriveFile,
    SendOutlined,
    SmsFailedOutlined
    } from '@mui/icons-material'

import { keyframes } from '@mui/system';
import EditCampaignDialog from '../Modules/EditCampaignDialog';
import ImageSlider from '../Modules/ImageSlider';

const getIntervalMs = (value, unit) => {
  switch (unit) {
    case "seconds":
      return value * 1000;
    case "minutes":
      return value * 60 * 1000;
    case "hours":
      return value * 60 * 60 * 1000;
    case "days":
      return value * 24 * 60 * 60 * 1000;
    case "weeks":
      return value * 7 * 24 * 60 * 60 * 1000;
    case "months":
      return value * 30 * 24 * 60 * 60 * 1000;
    default:
      return 0;
  }
};


  const InfoRow = ({ icon, title, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Box sx={{
        p: 0,
        bgcolor: 'background.default',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {icon}
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary">{title}</Typography>
        <Typography variant="body2" fontWeight="500">{value}</Typography>
      </Box>
    </Box>
  );
  
// Styled Components
const StyledCard = styled(Box)(({ theme }) => ({
   
    borderRadius: '5px',
    boxShadow: theme.shadows[1],
    transition: 'box-shadow 0.3s ease, transform 0.3s ease',
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[2],
    },
  }));
  
  const GradientHeader = styled(Box)(({ theme }) => ({
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
    color: theme.palette.common.white,
    padding: theme.spacing(2),
  }));

const StatusBadge = styled(Chip)(({ theme, status }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    outline: {
      SENT: theme.palette.success.light,
      PENDING: theme.palette.warning.light,
      ARCHIVE: theme.palette.success.light,
      FAILED: theme.palette.success.light,
      COMPLETED: theme.palette.success.light,
      PROCESSING: theme.palette.warning.light,
    }[status],
    color: theme.palette.getContrastText({
      SENT: theme.palette.success.light,
      PENDING: theme.palette.warning.light,
      ARCHIVE: theme.palette.success.light,
      FAILED: theme.palette.success.light,
      COMPLETED:theme.palette.success.light,
      PROCESSING: theme.palette.warning.light,
    }[status]),
  }));
  


  const getNextSendDate = (campaign, currentTime) => {
    if (campaign.type !== 'SCHEDULE') return null;
    try {
      const schedule = JSON.parse(campaign.filters || '{}');
      // Use the timeSlot if provided; otherwise, fall back to campaign.date_time
      const baseTime =
        schedule.timeSlot && schedule.timeSlot.trim() !== ''
          ? schedule.timeSlot
          : campaign.date_time;
          
      if (baseTime) {
        let nextSend = new Date(baseTime);
        const intervalMs =
          schedule.repeat && schedule.repeat.value && schedule.repeat.unit
            ? getIntervalMs(schedule.repeat.value, schedule.repeat.unit)
            : 86400000; // default to 24 hours if not specified
  
        // Loop until nextSend is in the future relative to currentTime
        while (nextSend < currentTime) {
          nextSend = new Date(nextSend.getTime() + intervalMs);
        }
        return nextSend;
      }
    } catch (e) {
      console.error('Error parsing schedule filters:', e);
    }
    return null;
  };
  

const getTimeRemainingString = (nextSend, currentTime) => {
  const diff = nextSend - currentTime;
  if (diff <= 0) return "00:00:00";
  const hours = Math.floor(diff / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

const getProgressPercentage = (campaign, currentTime) => {
    if (campaign.type !== 'SCHEDULE') return 0;
    try {
      const schedule = JSON.parse(campaign.filters || '{}');
      // Use timeSlot if provided; otherwise, fall back to campaign.date_time
      const baseTime =
        schedule.timeSlot && schedule.timeSlot.trim() !== ''
          ? schedule.timeSlot
          : campaign.date_time;
      if (baseTime) {
        // Determine the interval (defaulting to 24 hours if not set)
        const intervalMs =
          schedule.repeat && schedule.repeat.value && schedule.repeat.unit
            ? getIntervalMs(schedule.repeat.value, schedule.repeat.unit)
            : 86400000;
        // Compute the next scheduled time
        let nextSend = new Date(baseTime);
        while (nextSend < currentTime) {
          nextSend = new Date(nextSend.getTime() + intervalMs);
        }
        // The last send time is one interval before the next send
        const lastSend = new Date(nextSend.getTime() - intervalMs);
        const total = nextSend - lastSend;
        const elapsed = currentTime - lastSend;
        // Calculate the progress percentage
        return Math.min(100, Math.max(0, (elapsed / total) * 100));
      }
    } catch (e) {
      console.error(e);
    }
    return 0;
  };
  



// Truncate text if it's too long
const truncateText = (text, maxLength = 200) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};








// Analytics modal styled to match the theme.
const StyledModalPaper = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[24],
}));


const ActionButton = styled(IconButton)(({ theme }) => ({
    transition: 'transform 0.2s ease, background-color 0.2s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      backgroundColor: theme.palette.action.hover,
    },
  }));



  const professionalPulse = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
    filter: brightness(1);
    background-color: inherit;
    opacity: 1;
  }
  10% {
    transform: scale(1.08) rotate(2deg);
    filter: brightness(1.7);
    background-color: #ffffff;
    opacity: 1;
  }
  30% {
    transform: scale(0.92) rotate(-2deg);
    filter: brightness(0.9);
    background-color: #f0f0f0;
    opacity: 0.95;
  }
  50% {
    transform: scale(1.05) rotate(1deg);
    filter: brightness(1.2);
    background-color: #ffffff;
    opacity: 0.85;
  }
  70% {
    transform: scale(0.98) rotate(-1deg);
    filter: brightness(0.95);
    background-color: #f7f7f7;
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(0deg);
    filter: brightness(1);
    background-color: inherit;
    opacity: 1;
  }
`;



const CampaignCard = ({
  campaign,
  currentTime,
  onAnalyse,
  onDelete,
  onDuplicate,
  onPause,
  onEdit,
  onResume,
  getScheduleCampaigns
}) => {
  const theme = useTheme();
  const [elevation, setElevation] = useState(4);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  // State to trigger the advanced animation
  const [highlight, setHighlight] = useState(false);
  const prevTimeRef = useRef('');


  const handleSave = (updatedCampaign) => {
    onEdit(updatedCampaign);
    setEditOpen(false);
  };

  // Parse schedule data if available.
  let scheduleData = {};
  if (campaign.type === 'SCHEDULE' && campaign.filters) {
    try {
      scheduleData = JSON.parse(campaign.filters);
    } catch (error) {
      console.error("Error parsing campaign filters:", error);
    }
  }

  // Extract schedule details.
  const repeatValue = scheduleData?.repeat?.value;
  const repeatUnit = scheduleData?.repeat?.unit;
  const timeFormatted = scheduleData?.timeSlot
    ? new Date(scheduleData.timeSlot).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '';
  const daysFormatted = scheduleData?.dayFilter ? scheduleData.dayFilter.join(', ') : '';
  const scheduleStart = scheduleData?.start ? new Date(scheduleData.start).toLocaleDateString() : '';
  const scheduleEnd = scheduleData?.end ? new Date(scheduleData.end).toLocaleDateString() : '';

  // Build schedule text.
  const repeatText =
    repeatValue && repeatUnit
      ? `Repeat every ${repeatValue} ${repeatUnit}${repeatValue > 1 ? '' : ''}`
      : '';
  const scheduleTimeText = timeFormatted ? `at ${timeFormatted}` : '';
  const scheduleDaysText = daysFormatted ? `on ${daysFormatted}` : '';
  const schedulePeriodText = scheduleStart && scheduleEnd ? `(${scheduleStart} - ${scheduleEnd})` : '';
  const scheduleInfo =
    campaign.type === 'SCHEDULE'
      ? `${repeatText} ${scheduleDaysText} ${schedulePeriodText}`
      : '';

  // Calculate next send time and time remaining.
  // const nextSendDate = campaign.type === 'SCHEDULE' ? getNextSendDate(campaign, currentTime) : null;
  // const timeRemaining = nextSendDate ? getTimeRemainingString(nextSendDate, currentTime) : '';

  // Trigger the advanced pulse effect when timeRemaining transitions to "00:00:00"
  // useEffect(() => {
  //   if (prevTimeRef.current !== '00:00:00' && timeRemaining === '00:00:00') {
  //     setHighlight(true);
  //     const timer = setTimeout(() => setHighlight(false), 3000);
  //     setTimeout(()=>{
  //       getScheduleCampaigns()
  //     },10000)
  //     return () => clearTimeout(timer);
  //   }
  //   prevTimeRef.current = timeRemaining;
  // }, [timeRemaining]);

  // Decide which image to display.
  const previewImage =
    (campaign.number_of_files &&
      campaign.number_of_files.length > 0 &&
      '/api/files/download/' + campaign.number_of_files[0]) ||
    "https://user-images.githubusercontent.com/20684618/31289519-9ebdbe1a-aae6-11e7-8f82-bf794fdd9d1a.png";

  return (
    <>
      <StyledCard
        // elevation={elevation}
        // onMouseEnter={() => setElevation(8)}
        // onMouseLeave={() => setElevation(4)}
        sx={{
          borderRadius: 5,
          overflow: 'hidden',
          border: `1px solid ${theme.palette.divider}`,
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[2],
          // transition: 'box-shadow 0.3s ease, transform 0.3s ease',
          // Apply the advanced pulse animation if highlight is active
          // ...(highlight && {
          //   animation: `${professionalPulse} 0.6s ease-in-out 1`,
          // }),
        }}
      >
        {/* Square Image Section */}
        <ImageSlider campaign={campaign}/>

        {/* Main Content */}
        <Box sx={{ p: 2 }}>
          <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
            {campaign.message_text
              ? campaign.message_text.length > 300
                ? `${campaign.message_text.substring(0, 300)}...`
                : campaign.message_text
              : "No message content provided."}
          </Typography>
        </Box>
        {/* Recipients Display Section */}
        {campaign.recipients && campaign.recipients.length > 0 && (
            
              
            <Stack direction="row" mt={1} mb={1} ml={1} spacing={1} flexWrap="wrap">
            {campaign.recipients.map((recipient) => (
              <Chip
                key={recipient.id}
                label={recipient.name}
                variant="outlined"
                size="small"
                sx={{
                  borderRadius: 1,
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  borderColor: theme.palette.divider,
                  
                }}
              />
            ))}
          </Stack>
          
            
          )}
        {/* Modern Schedule Information */}
        {campaign.type === 'SCHEDULE' && (
          <Box
            sx={{
              p: 3,
              backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
              borderTop: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <CalendarTodayIcon fontSize="small" color="primary" />
              <Typography variant="subtitle2" sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
                {scheduleInfo}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={2}>
              {/* {nextSendDate && (
                <Chip
                  icon={<AccessTimeIcon fontSize="small" />}
                  label={`Next: ${nextSendDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: 2 }}
                />
              )}
              {timeRemaining && (
                <Chip
                  icon={<TimerIcon fontSize="small" />}
                  label={`In ${timeRemaining}`}
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: 2 }}
                />
              )} */}
            </Stack>
          </Box>
        )}

        {/* Additional Info Section */}
        {(campaign.message_sent_number ||
          campaign.message_failed_number ||
          (campaign.recipients && campaign.recipients.length > 0)) && (
          <Box
            sx={{
              p: 3,
              backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
              borderTop: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Stack direction="row" spacing={2}>
              <Chip label={`Sent: ${campaign.message_sent_number || 0}`} variant="outlined" size="small" />
              <Chip label={`Failed: ${campaign.message_failed_number || 0}`} variant="outlined" size="small" />
              <Chip
                label={`Recipients: ${campaign.recipients ? campaign.recipients.length : 0}`}
                variant="outlined"
                size="small"
              />
              <Chip
                label={`Attachments: ${campaign.number_of_files ? campaign.number_of_files.length : 0}`}
                variant="outlined"
                size="small"
              />
            </Stack>
            
            
          </Box>
        )}

        <Divider />

        {/* Actions Toolbar */}
        <Box
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Tooltip title="Analyse">
            <ActionButton onClick={() => onAnalyse(campaign)}>
              <Timeline color="action" />
            </ActionButton>
          </Tooltip>
          <Tooltip title="Duplicate">
            <ActionButton onClick={() => onDuplicate(campaign)}>
              <ContentCopy color="action" />
            </ActionButton>
          </Tooltip>
          <Tooltip title="Edit">
            <ActionButton onClick={() => setEditOpen(true)}>
              <Edit color="action" />
            </ActionButton>
          </Tooltip>
          <Tooltip title="Stop">
            <ActionButton onClick={() => onDelete(campaign.id)}>
              <StopCircle color="error" />
            </ActionButton>
          </Tooltip>
        </Box>
      </StyledCard>

      {/* Preview Modal can be placed here */}
      {editOpen && (
        <EditCampaignDialog
          campaign={campaign}
          onClose={() => setEditOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};

  

// Analytics Modal component.
const AnalyticsModal = ({ campaign, open, onClose, currentTime }) => {
  
  const theme = useTheme();
  if (campaign == null){return;}
  // Calculate next send and time remaining if applicable.
  // const nextSendDate = campaign && campaign.type === 'SCHEDULE' ? getNextSendDate(campaign, currentTime) : null;
  // const timeRemaining = nextSendDate ? getTimeRemainingString(nextSendDate, currentTime) : '';

  // Counts for recipients and files.
  const recipientsCount = campaign?.recipients ? campaign.recipients.length : 0;
  const fileCount = Array.isArray(campaign?.number_of_files) ? campaign.number_of_files.length : 0;

  // Parse schedule data.
  let scheduleData = {};
  if (campaign && campaign.type === 'SCHEDULE' && campaign.filters) {
    try {
      scheduleData = JSON.parse(campaign.filters);
    } catch (error) {
      console.error("Error parsing campaign filters:", error);
    }
  }
  const repeatValue = scheduleData?.repeat?.value;
  const repeatUnit = scheduleData?.repeat?.unit;
  const timeFormatted = scheduleData?.timeSlot
    ? new Date(scheduleData.timeSlot).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '';
  const daysFormatted = scheduleData?.dayFilter ? scheduleData.dayFilter.join(', ') : '';
  const scheduleStart = scheduleData?.start ? new Date(scheduleData.start).toLocaleDateString() : '';
  const scheduleEnd = scheduleData?.end ? new Date(scheduleData.end).toLocaleDateString() : '';

  const repeatText =
    repeatValue && repeatUnit
      ? `Repeat every ${repeatValue} ${repeatUnit}${repeatValue > 1 ? 's' : ''}`
      : '';
  const scheduleTimeText = timeFormatted ? `at ${timeFormatted}` : '';
  const scheduleDaysText = daysFormatted ? `on ${daysFormatted}` : '';
  const schedulePeriodText = scheduleStart && scheduleEnd ? `(${scheduleStart} - ${scheduleEnd})` : '';
  const scheduleInfo =
    campaign && campaign.type === 'SCHEDULE'
      ? `${repeatText} ${scheduleTimeText} ${scheduleDaysText} ${schedulePeriodText}`
      : 'N/A';

  return (
    <Modal open={open} onClose={onClose} BackdropProps={{ transitionDuration: 300 }}>
      <StyledModalPaper
        sx={{
          maxWidth: 1100,
          margin: 'auto',
          borderRadius: 3,
          overflow: 'hidden'
        }}
      >
        {campaign && (
          <Box sx={{ p: 1 }}>
            {/* Header Section */}
            <Box
              sx={{
                mb: 4,
                background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                p: 1,
                borderRadius: 2,
                position: 'relative',
                overflow: 'hidden',
                color: theme.palette.common.white,
                boxShadow: theme.shadows[2],
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -20,
                  right: -20,
                  width: 60,
                  height: 60,
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                },
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Timeline sx={{ fontSize: 32, color: 'inherit' }} />
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  Campaign Analytics
                </Typography>
              </Stack>
              <StatusBadge
              style={{color:"white"}}
                label={campaign.status == "PENDING" ? "In Progress" : "Completed"}
                status={campaign.status}
                sx={{ position: 'absolute', top: 16, right: 16 ,color:"white"}}
              />
            </Box>

            {/* Main Content */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <InfoRow icon={<Tag fontSize="small" />} title="Campaign ID" value={campaign.id} />
                <InfoRow
                  icon={<Person fontSize="small" />}
                  title="Created By"
                  value={`${campaign.send_by} (${campaign.sender})`}
                />
                <InfoRow
                  icon={<AccessTime fontSize="small" />}
                  title="Schedule"
                  value={scheduleInfo}
                />
                <InfoRow
                  icon={<CalendarToday fontSize="small" />}
                  title="Start - End Date"
                  value={campaign.date_time ? new Date(campaign.date_time).toLocaleString() : 'N/A'}
                />
                <InfoRow
                  icon={<Phone fontSize="small" />}
                  title="Sender Phone"
                  value={campaign.sender || "N/A"}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                {/* {campaign.type === 'SCHEDULE' && nextSendDate && (
                  <Box
                    sx={{
                      mb: 3,
                      p: 2,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 2,
                      textAlign: 'center'
                    }}
                  >
                    <Stack direction="row" spacing={2} justifyContent="center">
                      <Chip
                        label={`Next: ${nextSendDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
                        icon={<AccessTimeIcon />}
                        variant="outlined"
                        size="small"
                        sx={{ borderRadius: 2 }}
                      />
                      {timeRemaining && (
                        <Chip
                          label={`In ${timeRemaining}`}
                          icon={<TimerIcon />}
                          variant="outlined"
                          size="small"
                          sx={{ borderRadius: 2 }}
                        />
                      )}
                    </Stack>
                  </Box>
                )} */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    '& > *': {
                      flex: 1,
                      gap:2,
                      p:1,
                      borderRadius: 2,
                      border: `1px solid ${theme.palette.divider}`,
                      textAlign: 'center'
                    },
                  }}
                >
                  <Box>
                    <People color="primary" sx={{ fontSize: 32 }} />
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      {recipientsCount}
                    </Typography>
                    <Typography variant="caption">Recipients</Typography>
                  </Box>
                  <Box>
                    <InsertDriveFile color="secondary" sx={{ fontSize: 32 }} />
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      {fileCount}
                    </Typography>
                    <Typography variant="caption">Files</Typography>
                  </Box>
                  {/* <Box>
                  <SendOutlined color="primary" sx={{fontSize:32}}/>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      {campaign.message_sent_number || 0}
                    </Typography>
                    <Typography variant="caption">Sent</Typography>
                  </Box>
                  <Box>
                  <SmsFailedOutlined color="primary" sx={{fontSize:32}}/>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      {campaign.message_failed_number || 0}
                    </Typography>
                    <Typography variant="caption">Failed</Typography>
                  </Box> */}
                </Box>
              </Grid>
            </Grid>

            {/* Message Preview */}
            <Box
              sx={{
                mt: 3,
                p: 3,
                borderRadius: 2,
                backgroundColor: theme.palette.action.hover,
              }}
            >
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Message Preview
              </Typography>
              <Typography variant="body2" 
              
              sx={{ 
                mt: 1,
                maxHeight: 100, // Set your desired max height
                overflow: 'auto',
                whiteSpace: 'pre-wrap', // Preserve line breaks
                pr: 2 // Add right padding to avoid scrollbar overlap
              }}
              >
                {campaign.message_text || 'No message content'}
              </Typography>
            </Box>

            
            {/* Actions */}
            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant="contained"
                onClick={onClose}
                startIcon={<Close />}
                sx={{
                  px: 4,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    transform: 'translateY(-1px)',
                    boxShadow: theme.shadows[3],
                  },
                }}
              >
                Close Details
              </Button>
            </Box>
          </Box>
        )}
      </StyledModalPaper>
    </Modal>
  );
};

function CampaignManager() {
  const theme = useTheme();
  const [campaigns, setCampaigns] = useState([]);
  const [filters, setFilters] = useState({ 
    type: '', 
    status: '', 
    recipients: [],
    search: ''
  });
  const [currentTime, setCurrentTime] = useState(new Date());
  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 30,
    total: 0,
    totalPages: 1
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getScheduleCampaigns = async (page = 1) => {
    setIsLoading(true);
    try {
      const userID = JSON.parse(localStorage.getItem('user-data'))?.id;
      const params = {
        page,
        limit: pagination.limit,
        type: filters.type,
        status: filters.status,
        search: filters.search,
        recipients: filters.recipients.join(',')
      };
  
      // Create query string from params
      const queryParams = new URLSearchParams(params).toString();
      
      const response = await ApiService.get(
        `/api/chat/get_schedule_messages/${userID}?${queryParams}`
      );
  
      setCampaigns(response.data);
      setPagination(prev => ({
        ...prev,
        page,
        total: response.total,
        totalPages: Math.ceil(response.total / prev.limit)
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditCampaign = async (updatedCampaign) => {
    try {
      // Add your API call to update the campaign
      // await axios.put(`/api/campaigns/${updatedCampaign.id}`, updatedCampaign);
      ApiService.put('/api/chat/update/'+updatedCampaign.id,updatedCampaign)
      .then(res=>{
        if (res.success){getScheduleCampaigns(1,50);}

      }).catch(err =>{
        console.log(err)
      })
       // Refresh the list
    } catch (error) {
      console.error('Error updating campaign:', error);
    }
  };

  const handleDelete = (id) => {
    // setCampaigns((prev) => prev.filter((campaign) => campaign.id !== id));

    ApiService.post('/api/chat/set_archive',{"id":id})
    .then(res =>{
        // console.log(res)
        getScheduleCampaigns(1,50)
    }).catch(err =>{
        console.log(err)
    })
  };

  const handleAnalyse = (campaign) => {
    setSelectedCampaign(campaign);
    setAnalyticsOpen(true);
  };

  const handleDuplicate = (campaign) => {
    ApiService.post('/api/chat/duplicate',campaign)
    .then(res =>{
        // console.log(res)
        getScheduleCampaigns(1,50)
    }).catch(err =>{
        console.log(err)
    })
  };

  useEffect(() => {
    getScheduleCampaigns(pagination.page);
  }, [pagination.page, filters]);

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPagination(prev => ({ ...prev, page: newPage }));
    }
  };

  // Get unique recipients across all campaigns
  const allRecipients = useMemo(() => {
    const recipientMap = new Map();
    campaigns.forEach(campaign => {
      campaign.recipients?.forEach(recipient => {
        if (!recipientMap.has(recipient.id)) {
          recipientMap.set(recipient.id, recipient);
        }
      });
    });
    return Array.from(recipientMap.values());
  }, [campaigns]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container maxWidth="xxl" sx={{ py: 4 }}>
        <Box sx={{ mb: 4, textAlign: 'flex-start' }}>
          <Typography variant="h4" sx={{ fontWeight: '500', color: 'text.primary' }}>
            Active Message Campaigns ({pagination.total})
          </Typography>
        </Box>

        {/* Filters */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Campaign Type</InputLabel>
              <Select
                value={filters.type}
                onChange={(e) => handleFilterChange('type', e.target.value)}
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="INSTANT">Instant</MenuItem>
                <MenuItem value="SCHEDULE">Schedule</MenuItem>
                <MenuItem value="POSTPOND">Postponed</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Status</InputLabel>
              <Select
                value={filters.status}
                onChange={(e) => handleFilterChange('status', e.target.value)}
              >
                <MenuItem value="">All Statuses</MenuItem>
                <MenuItem value="COMPLETED">Completed</MenuItem>
                <MenuItem value="PENDING">Pending</MenuItem>
                <MenuItem value="PROCESSING">Processing</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Recipients</InputLabel>
              <Select
                multiple
                value={filters.recipients}
                onChange={(e) => handleFilterChange('recipients', e.target.value)}
                renderValue={(selected) => selected.map(id => 
                  allRecipients.find(r => r.id === id)?.name || 'Unknown'
                ).join(", ")}
              >
                {allRecipients.map(recipient => (
                  <MenuItem key={recipient.id} value={recipient.id}>
                    <Checkbox checked={filters.recipients.includes(recipient.id)} />
                    {recipient.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Search Messages"
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
            />
          </Grid>
        </Grid>

        {/* Campaign List */}
        <Grid container spacing={2}>
          {isLoading ? (
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Grid>
          ) : campaigns.length > 0 ? (
            campaigns.map((campaign) => (
              <Grid item xs={12} sm={6} md={4} key={campaign.id}>
                <CampaignCard
                  campaign={campaign}
                  currentTime={currentTime}
                  onAnalyse={() => {
                    setSelectedCampaign(campaign);
                    setAnalyticsOpen(true);
                  }}
                  onDelete={handleDelete}
                  onDuplicate={handleDuplicate}
                  onEdit={handleEditCampaign}
                />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                No campaigns found
              </Typography>
            </Grid>
          )}
        </Grid>

        {/* Pagination Controls */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, gap: 2 }}>
          <Button
            variant="outlined"
            onClick={() => handlePageChange(pagination.page - 1)}
            disabled={pagination.page === 1 || isLoading}
          >
            Previous
          </Button>
          
          <Typography variant="body1" sx={{ mx: 2, lineHeight: '36px' }}>
            Page {pagination.page} of {pagination.totalPages}
          </Typography>

          <Button
            variant="outlined"
            onClick={() => handlePageChange(pagination.page + 1)}
            disabled={pagination.page === pagination.totalPages || isLoading}
          >
            Next
          </Button>
        </Box>

        <AnalyticsModal
          campaign={selectedCampaign}
          open={analyticsOpen}
          onClose={() => setAnalyticsOpen(false)}
          currentTime={currentTime}
        />
      </Container>
    </LocalizationProvider>
  );
}

export default CampaignManager;
